angular
  .module 'filters'
  .filter 'mediumDate', ->
    (input) ->
      if input
        moment(input).format('MMM D, YYYY h:mma')
